import { Component, OnInit } from '@angular/core';
import { Transportista } from '../../../models/transportista';
import { Validation } from '../../../config/validation';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SweetMessage } from '../../../config/sweet-message';
import { SessionService } from '../../../services/session.service';
import { TransportistaService } from '../../../services/transportista.service';
import { AsyncLocalStorage } from 'angular-async-local-storage';

@Component({
  selector: 'app-transportista-edit',
  templateUrl: './transportista-edit.component.html',
  styleUrls: ['./transportista-edit.component.css'],
  providers: [SessionService,TransportistaService],

})
export class TransportistaEditComponent implements OnInit {

  myForm: FormGroup;
	public vl: Validation;
	public transportista:Transportista;
	public loading = false;
	public msg: SweetMessage;
	constructor(
    public fb: FormBuilder,
    private storage: AsyncLocalStorage,
		private ss: SessionService,
		private transportistaService: TransportistaService,
	) {
    this.msg = new SweetMessage();
		this.vl = new Validation();
		this.transportista = new Transportista();
		this.transportista.tipo_identificacion_id = 1;
	}

	ngOnInit() {
    this.storage.getItem("transportista").subscribe(data => {
      this.transportista = data;
    });
	}

	onSubmit() {
		//setea valores del formulario a la entidad
		this.setValueEntity();
		this.loading = true;
		this.transportistaService.update(this.transportista).subscribe(
			res => {
				this.loading = false;
				this.msg.showMessage('success-message', res.message);
			},
			err => {
				this.loading = false;
				this.msg.showMessage('error-message',err);
			}
		);
	}

	setValueEntity(){
		this.transportista.empresa_id = this.ss.getData("empresa_id");
		this.transportista.usuario_id = this.ss.getData("usuario_id");
	}

	// onForm() {
	// 	this.myForm = this.fb.group({
	// 		caja_id: ['', [Validators.required]],
	// 		tipo_comprobante_id: ['', [Validators.required]],
	// 	});
	// }

	// validErrorForm(campo) {
	// 	return this.vl.validErrorForm(campo, this.myForm);
	// }

	// validTypeMsgForm(nombre, campo) {
	// 	return this.vl.validTypeMsgForm(nombre, campo, this.myForm);
	// }

	onChangeIdentificacion(id){
		this.transportista.tipo_identificacion_id = id;
	}

	isValidForm(){
		
		
		if(this.transportista.dni){
			if(this.transportista.tipo_identificacion_id == 1 && this.transportista.dni.length != 13){
				return false;
			}
			if(this.transportista.tipo_identificacion_id == 2 && this.transportista.dni.length != 10){
				return false;
			}
			if(this.transportista.tipo_identificacion_id == 3 && this.transportista.dni.length < 4){
				return false;
			}
		}else{
			return false;
		}
		if( this.transportista.nombre.toString().trim().length < 1 ){
			return false;
		}
		if( this.transportista.placa.toString().trim().length < 1 ){
			return false;
		}

		

		return true;
	}

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/transportista-edit/transportista-edit.component.ts